import { inject, signal, WritableSignal } from "@angular/core";
import type { AccountManualType } from "@bitwarden/web-vault/app/models/types/account.types";

import { EarnService } from "@bitwarden/web-vault/app/services/earn/earn.service";
import { SignalSubscriptionImpl } from "@bitwarden/web-vault/app/components/tables/data-subscription";
import { getEarnVersionTableViews } from "@bitwarden/web-vault/app/components/tables/earn-tables/earn.table";
import { EarnVersion } from "@bitwarden/web-vault/app/models/types/earn.types";
import { EarnLookup } from "@bitwarden/web-vault/app/services/earn/lookup.service";

// todo move types to a separate file
export type TableSource = EarnVersion;
export type TableFilter = { [key in AccountManualType]: boolean };

/**
 * This class only need to deal with angular dependency
 * and the core logic is in getAccountTableViews function which can be easily unit tested
 */

export class EarnVersionTableSubscription extends SignalSubscriptionImpl<TableSource[]> {
  protected filter: WritableSignal<TableFilter> = signal<TableFilter>(null);
  earnService: EarnService;
  earnLookup: EarnLookup;

  constructor() {
    super();
    this.earnService = inject(EarnService);
    this.earnLookup = inject(EarnLookup);
  }

  get source() {
    const masks = this.earnService.maskList();
    return getEarnVersionTableViews(masks).map((earnVersionTable) => this.enrich(earnVersionTable));
  }

  private enrich(m: EarnVersion): EarnVersion {
    const groupKey = this.yyyyMm01(m.publishedAt);
    const versionLabel = `${groupKey}.v${m.version}`;
    return { ...m, groupKey, versionLabel };
  }

  private yyyyMm01(iso: string): string {
    const d = new Date(iso);
    const y = d.getFullYear();
    const m = (d.getMonth() + 1).toString().padStart(2, "0");
    return `${y}${m}01`;
  }
}
